import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';
import ServicesMarquee from '../components/ServicesMarquee';

const CookiePolicy = () => {
    const { t } = useLanguage();
    usePageTitle('cookiePolicy');

    return (
        <div className="inner-page-content">
            {/* Cookie Policy Section Start */}
            <div className="mxd-section mxd-section-inner-headline padding-default">
                <ServicesMarquee order={[5, 4, 3, 2, 1, 0]} />

                <div className="mxd-container grid-container">
                    <div className="mxd-block loading-wrap">
                        <div className="container-fluid px-0">
                            <div className="row gx-0 justify-content-center">
                                <div className="col-12 col-xl-8">
                                    {/* Header */}
                                    <div className="mb-5 pb-4 text-center border-bottom">
                                        <h1 className="reveal-type loading__item mb-3" style={{
                                            fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                                            fontWeight: '600'
                                        }}>
                                            {t('cookiePolicy.title')}
                                        </h1>
                                        <p className="loading__item anim-uni-in-up text-muted" style={{
                                            fontSize: '0.95rem'
                                        }}>
                                            {t('cookiePolicy.lastUpdate')}
                                        </p>
                                    </div>

                                    {/* Content */}
                                    <div className="cookie-policy-content" style={{
                                        maxWidth: '800px',
                                        margin: '0 auto',
                                        fontSize: '1.1rem',
                                        lineHeight: '1.8'
                                    }}>

                                        {/* Intro */}
                                        <section className="mb-5 loading__item anim-uni-in-up">
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.intro.title')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.intro.description')}
                                            </p>
                                        </section>

                                        {/* Types of Cookies */}
                                        <section className="mb-5 loading__item anim-uni-in-up">
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.types.title')}
                                            </p>

                                            {/* Necessary Cookies */}
                                            <div className="mb-5">
                                                <p className="mb-3" style={{ fontSize: '1.2rem' }}>
                                                    {t('cookiePolicy.types.necessary.title')}
                                                </p>
                                                <p className="mb-4">
                                                    {t('cookiePolicy.types.necessary.description')}
                                                </p>
                                                <p className="mb-4">
                                                    {t('cookiePolicy.types.necessary.items').map((item, index) => (
                                                        <span key={index}>
                                                            {index > 0 && ' '}
                                                            <code style={{
                                                                background: 'var(--color-background-alt)',
                                                                padding: '0.25rem 0.6rem',
                                                                borderRadius: '6px',
                                                                fontSize: '1rem',
                                                                fontFamily: 'monospace'
                                                            }}>
                                                                {item}
                                                            </code>
                                                            {index < t('cookiePolicy.types.necessary.items').length - 1 && ', '}
                                                        </span>
                                                    ))}
                                                </p>
                                            </div>

                                            {/* Analytics Cookies */}
                                            <div className="mb-5 pb-4" style={{ borderBottom: '1px solid var(--color-border)' }}>
                                                <p className="mb-3" style={{ fontSize: '1.2rem' }}>
                                                    {t('cookiePolicy.types.analytics.title')}
                                                </p>
                                                <p className="mb-4">
                                                    {t('cookiePolicy.types.analytics.description')}
                                                </p>
                                                <p className="mb-4">
                                                    Las cookies de Google Analytics que utilizamos incluyen:{' '}
                                                    {t('cookiePolicy.types.analytics.items').map((item, index) => (
                                                        <span key={index}>
                                                            <code style={{
                                                                background: 'var(--color-background-alt)',
                                                                padding: '0.25rem 0.6rem',
                                                                borderRadius: '6px',
                                                                fontSize: '1rem',
                                                                fontFamily: 'monospace'
                                                            }}>
                                                                {item}
                                                            </code>
                                                            {index < t('cookiePolicy.types.analytics.items').length - 1 ? ', ' : '.'}
                                                        </span>
                                                    ))}
                                                </p>
                                                <p className="mb-2">
                                                    <strong>{t('cookiePolicy.types.analytics.provider')}</strong>
                                                </p>
                                                <p>
                                                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                                                        {t('cookiePolicy.types.analytics.privacy')}
                                                    </a>
                                                </p>
                                            </div>

                                            {/* Advertising Cookies - Google Ads */}
                                            <div className="mb-5 pb-4" style={{ borderBottom: '1px solid var(--color-border)' }}>
                                                <p className="mb-3" style={{ fontSize: '1.2rem' }}>
                                                    {t('cookiePolicy.types.advertising.google.title')}
                                                </p>
                                                <p className="mb-4">
                                                    {t('cookiePolicy.types.advertising.google.description')}
                                                </p>
                                                <p className="mb-4">
                                                    Las cookies de Google Ads que implementamos son:{' '}
                                                    {t('cookiePolicy.types.advertising.google.items').map((item, index) => (
                                                        <span key={index}>
                                                            <code style={{
                                                                background: 'var(--color-background-alt)',
                                                                padding: '0.25rem 0.6rem',
                                                                borderRadius: '6px',
                                                                fontSize: '1rem',
                                                                fontFamily: 'monospace'
                                                            }}>
                                                                {item}
                                                            </code>
                                                            {index < t('cookiePolicy.types.advertising.google.items').length - 1 ? ', ' : '. '}
                                                        </span>
                                                    ))}
                                                    Estas cookies nos permiten optimizar nuestras campañas publicitarias y mejorar su rendimiento.
                                                </p>
                                                <p className="mb-2">
                                                    <strong>{t('cookiePolicy.types.advertising.google.provider')}</strong>
                                                </p>
                                                <p>
                                                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                                                        {t('cookiePolicy.types.advertising.google.privacy')}
                                                    </a>
                                                </p>
                                            </div>

                                            {/* Advertising Cookies - Facebook Pixel */}
                                            <div className="mb-5 pb-4" style={{ borderBottom: '1px solid var(--color-border)' }}>
                                                <p className="mb-3" style={{ fontSize: '1.2rem' }}>
                                                    {t('cookiePolicy.types.advertising.facebook.title')}
                                                </p>
                                                <p className="mb-4">
                                                    {t('cookiePolicy.types.advertising.facebook.description')}
                                                </p>
                                                <p className="mb-4">
                                                    El Facebook Pixel utiliza las siguientes cookies:{' '}
                                                    {t('cookiePolicy.types.advertising.facebook.items').map((item, index) => (
                                                        <span key={index}>
                                                            <code style={{
                                                                background: 'var(--color-background-alt)',
                                                                padding: '0.25rem 0.6rem',
                                                                borderRadius: '6px',
                                                                fontSize: '1rem',
                                                                fontFamily: 'monospace'
                                                            }}>
                                                                {item}
                                                            </code>
                                                            {index < t('cookiePolicy.types.advertising.facebook.items').length - 1 ? ', ' : '. '}
                                                        </span>
                                                    ))}
                                                    Estas cookies nos ayudan a medir la efectividad de nuestros anuncios en las redes sociales de Meta.
                                                </p>
                                                <p className="mb-2">
                                                    <strong>{t('cookiePolicy.types.advertising.facebook.provider')}</strong>
                                                </p>
                                                <p>
                                                    <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                                                        {t('cookiePolicy.types.advertising.facebook.privacy')}
                                                    </a>
                                                </p>
                                            </div>
                                        </section>

                                        {/* Consent */}
                                        <section className="mb-5 loading__item anim-uni-in-up">
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.consent.title')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.consent.description')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.consent.manage')}
                                            </p>
                                        </section>

                                        {/* Rights */}
                                        <section className="mb-5 loading__item anim-uni-in-up">
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.rights.title')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.rights.description')}
                                            </p>
                                            <p className="mb-4">
                                                Puedes {t('cookiePolicy.rights.items')[0].toLowerCase()}, {t('cookiePolicy.rights.items')[1].toLowerCase()}, {t('cookiePolicy.rights.items')[2].toLowerCase()} y {t('cookiePolicy.rights.items')[3].toLowerCase()}. Estos derechos te garantizan un control total sobre tu privacidad y la información que compartimos.
                                            </p>
                                        </section>

                                        {/* Manage Cookies */}
                                        <section className="mb-5 loading__item anim-uni-in-up">
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.manage_cookies.title')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.manage_cookies.description')} {t('cookiePolicy.manage_cookies.browser')}
                                            </p>
                                            <div className="ps-3 mb-4">
                                                {t('cookiePolicy.manage_cookies.browsers').map((browser, index) => {
                                                    const [name, url] = browser.split(': ');
                                                    return (
                                                        <p key={index} className="mb-3">
                                                            <strong>{name}:</strong>{' '}
                                                            <a href={url} target="_blank" rel="noopener noreferrer" className="text-decoration-underline" style={{ wordBreak: 'break-all' }}>
                                                                {url}
                                                            </a>
                                                        </p>
                                                    );
                                                })}
                                            </div>
                                        </section>

                                        {/* Contact */}
                                        <section className="mb-5 loading__item anim-uni-in-up p-4" style={{
                                            background: 'var(--color-card-background)',
                                            borderRadius: '12px',
                                            border: '1px solid var(--color-border)'
                                        }}>
                                            <p className="mb-4" style={{ fontSize: '1.3rem', fontWeight: '500' }}>
                                                {t('cookiePolicy.contact.title')}
                                            </p>
                                            <p className="mb-4">
                                                {t('cookiePolicy.contact.description')}
                                            </p>
                                            <p className="mb-3">
                                                <i className="ph-bold ph-envelope me-2"></i>
                                                <strong>{t('cookiePolicy.contact.email')}</strong>
                                            </p>
                                            <p className="mb-0">
                                                <i className="ph-bold ph-map-pin me-2"></i>
                                                <strong>{t('cookiePolicy.contact.address')}</strong>
                                            </p>
                                        </section>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ServicesMarquee />
            {/* Cookie Policy Section End */}
        </div>
    );
};

export default CookiePolicy;

